import { Typography } from '@mui/material';
import { ScopeT, UserScopesT } from 'business/definitions';
import React from 'react';
import Flex from 'ui/Flex/Flex';
import BlockEditor from './BlockEditor';
import { getScopeExpressionKey } from 'helpers/scopes';
import { BlockValueRemover, BlockValuesUpdater } from '../../hooks/blockValues';

interface ScopeBlocksEditorProps {
    scope: ScopeT;
    userScopes: UserScopesT;
    title: string;
    blocks: string[];
    onUpdateBlockValues: BlockValuesUpdater;
    onRemoveBlockValue: BlockValueRemover;
}

const ScopeBlocksEditor = ({
    scope,
    userScopes,
    title,
    blocks,
    onUpdateBlockValues,
    onRemoveBlockValue,
}: ScopeBlocksEditorProps) => {
    const expressionType = getScopeExpressionKey(scope);
    if (!expressionType) {
        return <></>;
    }
    return (
        <Flex flexDirection="column" gap={2}>
            <Typography>{title}</Typography>
            {blocks.map((block) => (
                <BlockEditor
                    key={block}
                    block={block}
                    scope={scope}
                    userScopes={userScopes}
                    onUpdateBlockValues={onUpdateBlockValues}
                    onRemoveBlockValue={onRemoveBlockValue}
                />
            ))}
        </Flex>
    );
};

export default ScopeBlocksEditor;
